import {UmpireComponent} from '../umpire-component';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireImage} from '../umpire-image';

export interface UmpireComponentVideo
  extends UmpireComponent<UmpireComponentTypeEnum.VIDEO> {
  video: UmpireImage;
}
